module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-f048f7d2b843d78a630560e49982e71b.jpg";